<app-layer-details-length-row
  label="Length"
  [value]="layer.data.length"
  [unitsSystem]="unitsSystem"
></app-layer-details-length-row>
